<template>
  <button
    type="button"
    class="ee-avatar-btn"
    :aria-label="user ? tm('profile', 'Profile') : tm('log_in', 'Log in')"
    @click="open"
  >
    <span v-if="user" class="ee-avatar" :style="{ '--h': hue }">{{ initials }}</span>
    <span v-else class="material-symbols-outlined">account_circle</span>
  </button>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import navigateMixin from '../../mixins/navigate'
import i18nMixin from '../../modern/i18n'

// Header avatar -> participant profile (my_profile menu item if the event has one, else /profile)
export default {
  mixins: [navigateMixin, i18nMixin],

  computed: {
    ...mapState({ user: state => state.auth.user }),
    ...mapGetters('common', ['rootMenu']),

    initials () {
      return `${(this.user.firstname || ' ')[0]}${(this.user.surname || ' ')[0]}`.toUpperCase()
    },

    hue () {
      return [...`${this.user.firstname}${this.user.surname}`].reduce((sum, c) => sum + c.charCodeAt(0), 0) % 360
    },
  },

  methods: {
    open () {
      const item = this.$store.state.common.menu.find(i => i.module === 'my_profile' && i.enabled)
      this.navigateTo(item || '/profile')
    },
  },
}
</script>
